const TOKEN_RE = /\{\{\s*([A-Za-z_][\w-]*)\s*=\s*([^}]*?)\s*\}\}/g


export function extractRegionValues(template, currentCode) {
    if (typeof template !== 'string' || typeof currentCode !== 'string')
        return null
    const fixed = []
    const ids = []
    let last = 0
    let m
    TOKEN_RE.lastIndex = 0
    while ((m = TOKEN_RE.exec(template)) !== null) {
        fixed.push(template.slice(last, m.index))
        ids.push(m[1])
        last = m.index + m[0].length
    }
    fixed.push(template.slice(last))

    if (ids.length === 0) return {}
    if (!currentCode.startsWith(fixed[0])) return null

    const values = {}
    let pos = fixed[0].length
    for (let i = 0; i < ids.length; i++) {
        const nextSeg = fixed[i + 1]
        let idx
        if (nextSeg === '') {
            idx = currentCode.length
        } else {
            idx = currentCode.indexOf(nextSeg, pos)
            if (idx === -1) return null
        }
        values[ids[i]] = currentCode.slice(pos, idx)
        pos = idx + nextSeg.length
    }
    return values
}

export function parseTemplate(template, values = {}) {
    if (typeof template !== 'string') return { code: '', regions: [] }

    let code = ''
    let line = 1
    let column = 1
    const regions = []

    const appendPlain = (text) => {
        for (const ch of text) {
            code += ch
            if (ch === '\n') {
                line++
                column = 1
            } else {
                column++
            }
        }
    }

    let lastIndex = 0
    let match
    TOKEN_RE.lastIndex = 0
    while ((match = TOKEN_RE.exec(template)) !== null) {
        const [full, id, def] = match
        appendPlain(template.slice(lastIndex, match.index))

        const value = Object.prototype.hasOwnProperty.call(values, id)
            ? String(values[id])
            : def
        const startLineNumber = line
        const startColumn = column
        appendPlain(value)
        regions.push({
            id,
            startLineNumber,
            startColumn,
            length: value.length,
            defaultValue: def,
        })
        lastIndex = match.index + full.length
    }
    appendPlain(template.slice(lastIndex))

    return { code, regions }
}

export function templateRegionIds(template) {
    return parseTemplate(template).regions.map((r) => r.id)
}

export function templateDefaults(template) {
    const map = {}
    parseTemplate(template).regions.forEach((r) => {
        map[r.id] = r.defaultValue
    })
    return map
}

export function offsetToLineCol(code, offset) {
    const before = String(code).slice(0, Math.max(0, offset))
    const line = before.split('\n').length
    const lastNl = before.lastIndexOf('\n')
    const column = offset - lastNl
    return { line, column }
}

export function selectionToRange(code, start, end) {
    const a = offsetToLineCol(code, start)
    const b = offsetToLineCol(code, end)
    return {
        startLineNumber: a.line,
        startColumn: a.column,
        endLineNumber: b.line,
        endColumn: b.column,
    }
}
